import Wrapper from '@/components/MdxViewer';
import RoundBox from '@/snippets/RoundBox';
import { Box, Container } from '@mui/material';

import projectData from './data';
import LogoAnimation from './LogoAnimation';
import Markdown from './markdown.mdx';

const Block = () => {
    return (
        <Box>
            <RoundBox variant="top" darken={.3} shift zIndex={2} bgcolor='background'>
                <Box sx={{
                    minHeight: '50vh',
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    py: 10,
                }}>
                    <LogoAnimation size={250} followCursor />
                </Box>
            </RoundBox>
            <RoundBox variant="both" darken={.4} zIndex={3} bgcolor='background'>
                <Container maxWidth="lg">
                    <Box py={20}>
                        <Wrapper
                            filePath={projectData.filePath}
                            Component={Markdown} />
                    </Box>
                </Container>
            </RoundBox>
        </Box>
    )
}

export default Block;